<template>
    <div>
        <div
            :class="[
                'search-box',
                { active: search != '' && search.length > 2 },
            ]"
            ref="list"
        >
            <div style="display: flex">
                <input
                    ref="field"
                    :class="[{ 'has-error': validationError }]"
                    :type="type ? type : 'text'"
                    autocomplete="new-password"
                    onkeypress="if(this.value.length==this.maxLength) return false;"
                    @blur="checkLabel"
                    @input="updateValue($event.target.value)"
                    :placeholder="placeholder"
                    v-model="search"
                    @focus="activate"
                    :maxlength="maxlength"
                />

                <img
                    v-if="
                        directSearchAccessValue &&
                        search != '' &&
                        search.length > (minlength ? minlength : 5)
                    "
                    src="@/assets/images/CHECK-Mark.svg"
                    style="width: 15px"
                />
            </div>
            <div
                :class="[
                    'search-dropdown',
                    { show: showResults && search != '' && isActive },
                ]"
            >
                <ul>
                    <li
                        v-for="(d, index) in results"
                        :key="index"
                        :id="d.id"
                        @click="setValue(isGetByID ? d : d.name)"
                    >
                        {{ d.name }}
                    </li>
                </ul>
            </div>
        </div>
        <div
            :class="['validation-error', { 'show-error': validationError }]"
            v-if="!noError"
        >
            {{ messageError }}
        </div>
    </div>
</template>

<script>
import patterns from "@/validations/patterns";

export default {
    props: {
        type: {
            type: String,
        },
        data: {
            type: Array,
        },
        value: {
            type: String,
        },
        isGetByID: {
            type: Boolean,
        },
        placeholder: {
            type: String,
            default: "",
        },
        validate: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        noError: {
            type: Boolean,
            default: false,
        },
        rule: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: "",
        },
        capitalize: {
            type: Boolean,
            default: false,
        },
        isZipCode: {
            type: Boolean,
            default: false,
        },
        directSearchAccessValue: {
            default: "",
        },
        maxlength: {
            type: Number,
        },
        minlength: {
            type: Number,
        },
    },
    data() {
        return {
            search: "",
            isActive: false,
            showResults: false,
            validationError: false,
            messageError: "",
        };
    },
    methods: {
        test(n) {
            if (!n) {
                if (
                    document.activeElement != this.$refs.list ||
                    !this.$refs.list.contains(this.$refs.list)
                ) {
                    this.isActive = false;
                }
            }
            this.isActive = n;
        },
        activate() {
            this.isActive = true;
        },
        setValue(n) {
            this.search = this.isGetByID
                ? n.name.replace(/[0-9]/g, "").replace(/^\s+|\s+$/g, "")
                : n;
            this.isActive = false;
            this.updateValue(n);
        },
        updateValue(value) {
            this.validateInput();
            this.$emit("input", value);
        },
        validateInput() {
            if (this.validate == "") {
                this.$emit("value", this.value);
            } else {
                if (this.value == "") {
                    this.validationError = false;
                } else {
                    let p,
                        m = "";
                    if (this.validate == "custom") {
                        p = new RegExp(`^${this.rule}`);
                        m = this.message;
                    } else if (this.validate == "text-input") {
                        this.value = this.value.replace(/[^A-Za-z]/gi, "");
                    } else if (this.validate == "number-input") {
                        this.value = this.value.replace(/[^0-9]/g, "");
                    } else if (this.validate == "address-input") {
                        this.value = this.value.replace(
                            /[^0-9a-zA-Z|^.|^#|^,]/gi,
                            ""
                        );
                    } else {
                        p = patterns[`${this.validate}`];
                        m = patterns.errors[`${this.validate}`];
                    }
                    if (this.value.match(p)) {
                        this.validationError = false;
                        this.$emit("value", this.value);
                    } else {
                        this.validationError = true;
                        this.messageError = m;
                    }
                }
            }
        },
        checkLabel() {
            if (this.value == "") {
                if (this.required) {
                    this.validationError = true;
                    this.messageError = this.$t("Please add a valid info");
                }
            } else if (this.validate == "") {
                this.validationError = false;
            }
        },
        check() {
            this.validateInput();
            this.checkLabel();
            return this.validationError;
        },
        // handleClicks() {
        //         if ((document.activeElement != this.$refs.list || !(this.$refs.list.contains(document.activeElement))) ) {
        //             this.isActive = false
        //         }
        // }
    },
    // mounted() {
    //     document.addEventListener('click', this.handleClicks)
    // },
    // beforeDestroy() {
    //     document.removeEventListener('click', this.handleClicks)
    // },
    computed: {
        results() {
            let x = new RegExp(this.search, "i");
            let r = this.data.filter((d) => {
                return x.test(d.name);
            });
            if (r === undefined || r.length == 0) {
                this.showResults = false;
            } else {
                this.showResults = true;
            }
            return r;
        },
    },
    watch: {
        value() {
            this.search = this.value;
            this.setValue(this.value);
        },
        directSearchAccessValue: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.search = this.directSearchAccessValue;
                this.setValue(this.directSearchAccessValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
img {
    position: absolute;
    bottom: 7px;
    right: 7px;
}

.search-box {
    display: inline-block;
    width: 100%;
    border-bottom: 1px solid #ddd;
    padding: 5px 0 2px 0;
    position: relative;

    .search-dropdown {
        position: absolute;
        display: none;
        top: calc(100% + 2px);
        left: 0;
        background-color: white;
        width: 100%;
        box-shadow: 0 8px 15px 0 rgba(217, 217, 217, 0.3);
        z-index: 500;
        overflow-x: scroll;
        max-height: 200px;

        ul li {
            text-align: left;
            padding: 7px 15px;
            border-top: 1px solid #d7d7d7;
            cursor: pointer;

            span {
                display: inline-block;
                height: 100%;
                width: 100%;
            }
        }
    }

    .search-dropdown.show {
        display: block;
    }

    input {
        width: 100%;
        color: #444444;
        font-size: 1em;
        font-weight: bold;

        &:focus {
            outline: none;
        }
    }
}

$primary: #ffcb04;
$error: #eb6174;

input {
    background-color: transparent;

    &:enabled {
        outline: none !important;
    }
}

.capitalize {
    text-transform: capitalize !important;
}

.custom-input {
    position: relative;
    display: inline-block;
    border-bottom: 1px solid #ddd;

    &::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        top: 100%;
        width: 100%;
        height: 1px;
        border: 1px solid $primary;
        background: $primary;
        z-index: 5;
        transform: scaleX(0);
        transform-origin: left;
        transition: 0.4s linear;
    }

    &::after {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        top: 100%;
        width: 100%;
        height: 1px;
        border: 1px solid $error;
        background: $error;
        z-index: 8;
        transform: scaleX(0);
        transform-origin: left;
        transition: 0.4s linear;
    }

    &.active::before {
        transform: scaleX(1);
    }

    &.has-error::after {
        transform: scaleX(1);
    }

    p {
        position: absolute;
        display: block;
        top: -5px;
        right: 0;
        font-size: 1.4em;
        margin-right: 15px;
        margin-top: 5px;
        cursor: pointer;
    }

    input {
        width: 100%;
        border-radius: 10px;
        padding: 10px 5px 2px 5px;
        color: #444444;
        font-size: 1em;
        font-weight: 500;
        transition: 0.25s ease-out;
        display: inline-block;
    }
}

.validation-error {
    transition: 0.25s ease-in-out;
    color: #eb6174 !important;
    position: absolute;
    font-size: 13px;
    top: calc(100% + 2px);
    left: 5px;
    visibility: hidden;
}

.validation-error.show-error {
    visibility: visible !important;
}
</style>
